import React, { useState } from "react";
import { Row, Col, Card, Table, Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import { FaPlus, FaRedo, FaFilter, FaSort, FaSearch, FaEye, FaTrashAlt, FaEdit } from "react-icons/fa";

const initialData = [
  {
    partnerName: "Asif",
    accountName: "Savings Account",
    type: "Debit Card",
    accountNumber: "1234567890123456",
  },
  {
    partnerName: "Bilal",
    accountName: "Checking Account",
    type: "Credit Card",
    accountNumber: "9876543210987654",
  },
  {
    partnerName: "Cynthia",
    accountName: "Business Account",
    type: "Debit Card",
    accountNumber: "5678901234567890",
  },
];

const AccountsTable = () => {
  const [data, setData] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = data.filter(
    (item) =>
      item.partnerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.accountName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.type.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });
    setSortConfig({ key, direction });
    setData(sortedData);
  };

  const handleDelete = (index) => {
    const newData = data.filter((_, i) => i !== index);
    setData(newData);
    alert(`Entry ${index + 1} deleted successfully.`);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const maskAccountNumber = (number) => {
    return `**** **** **** ${number.slice(-4)}`;
  };

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Button variant="primary" className="d-flex align-items-center">
                <FaPlus className="me-2" /> Accounts
              </Button>
              <div className="d-flex align-items-center">
                <Button variant="light" className="me-2">
                  <FaFilter />
                </Button>
                <Button variant="light" className="me-2">
                  <FaRedo />
                </Button>
                <InputGroup style={{ width: "300px" }}>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="rounded"
                  />
                </InputGroup>
              </div>
            </Card.Header>
            <Card.Body>
              <div
                className="table-responsive border border-secondary rounded"
                style={{ padding: "1rem" }}
              >
                <Table hover>
                  <thead>
                    <tr>
                      <th onClick={() => handleSort("partnerName")}>
                        Partner Name <FaSort />
                      </th>
                      <th onClick={() => handleSort("accountName")}>
                        Account Name <FaSort />
                      </th>
                      <th onClick={() => handleSort("type")}>
                        Type <FaSort />
                      </th>
                      <th onClick={() => handleSort("accountNumber")}>
                        Account Number <FaSort />
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((item, index) => (
                      <tr key={index}>
                        <td className="d-flex align-items-center">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              backgroundColor: "#007bff",
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "bold",
                              marginRight: "10px",
                            }}
                          >
                            {item.partnerName[0]}
                          </div>
                          {item.partnerName}
                        </td>
                        <td>{item.accountName}</td>
                        <td>{item.type}</td>
                        <td>{maskAccountNumber(item.accountNumber)}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              size="sm"
                              className="border-0"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => alert(`View entry ${index + 1}`)}>
                                <FaEye className="me-2 text-primary" /> View
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => alert(`Edit entry ${index + 1}`)}>
                                <FaEdit className="me-2 text-info" /> Edit
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => handleDelete(index)}>
                                <FaTrashAlt className="me-2 text-danger" /> Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {!filteredData.length && (
                  <p className="text-center">No results found.</p>
                )}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing {startIndex + 1} to{" "}
                    {Math.min(startIndex + itemsPerPage, filteredData.length)} of{" "}
                    {filteredData.length} entries
                  </div>
                  <div>
                    {[...Array(pageCount).keys()].map((page) => (
                      <Button
                        key={page}
                        variant="light"
                        className={`me-1 ${
                          currentPage === page + 1 ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page + 1)}
                      >
                        {page + 1}
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AccountsTable;
